import { API_SPOT_HAVAS_ERROR_REFERENCE } from '@/services/validation/erreurReferenceHavas';

export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  const i18nType = 'devis.errors';
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    const nbMessagesAvant = messages.length;
    if (message.indexOf(API_SPOT_HAVAS_ERROR_REFERENCE) === 0) return;
    if (error.members && error.members.length > 0) {
      const property = error.members[0]
      if (property === 'theme') {
        messages.push({
          message: i18nType + '.themeRequired',
        });
      }
    }
    if (message.indexOf('LEAST_ONE_CUSTOMER') === 0) {
      messages.push({
        message: i18nType + '.leastOneCustomer',
      });
    }
    if (message.indexOf('SHOULD_CONTAINS_AT_LEAST_ONE_LINE') === 0) {
      messages.push({
        message: i18nType + '.leastOneProduct',
      });
    }
    if (message.indexOf('NORMAL_LINE_REQUIRED_BETWEEN_2_DISCOUNT_LINE') === 0) {
      messages.push({
        message: i18nType + '.normalLine',
      });
    }
    if (message.indexOf('MUST_SELECT_A_PUBLICATION') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.parutionNeeded',
        parametres: {
          produit: elements[1],
        },
      });
    }
    if (message.indexOf('SUM_MUST_BE_100') === 0) {
      messages.push({
        message: i18nType + '.noMoreOneHundred',
      });
    }
    if (message.indexOf('TIMETABLE_S_COMMAND_LINES_SHOULD_HAVE_SAME_BILLING_TYPE') === 0) {
      messages.push({
        message: i18nType + '.sameBillingType',
      });
    }
    if (message.indexOf('DISCOUNT_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.needDiscount',
      });
    }
    if (message.indexOf('LEAST_ONE_ADVERTISER') === 0) {
      messages.push({
        message: i18nType + '.leastOneAdvertiser',
      });
    }
    if (message.indexOf('TIMETABLE_S_COMMAND_LINES_SHOULD_HAVE_SAME_SUPPLIER') === 0) {
      messages.push({
        message: i18nType + '.sameSupplier',
      });
    }
    if (message.indexOf('LEAST_ONE_PAYER') === 0) {
      messages.push({
        message: i18nType + '.leastOnePayer',
      });
    }
    if (message.indexOf('POURCENTAGE_DIVISION') === 0) {
      messages.push({
        message: i18nType + '.pourcentageDivision',
      });
    }
    if (message.indexOf('NOT_SAME_DIVISION_TYPE') === 0) {
      messages.push({
        message: i18nType + '.notSameDivisionType',
      });
    }
    if (message.indexOf('AMOUNT_DIVISION') === 0) {
      messages.push({
        message: i18nType + '.amountDivision',
      });
    }
    if (message.indexOf('PROXY_NOT_REPRESENTATIVE') === 0) {
      messages.push({
        message: i18nType + '.proxyNotRepresentative',
      });
    }
    if (message.indexOf('LEAST_ONE_PRODUCT') === 0) {
      messages.push({
        message: i18nType + '.leastOneProduct',
      });
    }
    if (message.indexOf('UNIT_PRICE_LESS_ZERO') === 0) {
      messages.push({
        message: i18nType + '.unitPriseLessZero',
      });
    }
    if (message.indexOf('QUANTITY_LESS_ZERO') === 0) {
      messages.push({
        message: i18nType + '.quantityLessZero',
      });
    }
    if (message.indexOf('DISCOUNT_BETWEEN_0_100') === 0) {
      messages.push({
        message: i18nType + '.discountBetween0100',
      });
    }
    if (message.indexOf('DISCOUNT_BETWEEN_0_AMOUNT') === 0) {
      messages.push({
        message: i18nType + '.discountBetween0Amount',
      });
    }
    if (message.indexOf('ACOMPTE_MULTI_PAYER_FORBIDDEN') === 0) {
      messages.push({
        message: i18nType + '.acompteMultipayeurForbidden',
      });
    }
    if (message.indexOf('TAUX_TVA_SHOULD_BE_ZERO_WITH_ANNONCEUR_WITH_EXONERATION_TVA') === 0) {
      messages.push({
        message: i18nType + '.ligneCommandeWithZeroTva',
      });
    }
    if (message.indexOf('ANNONCEUR_MUST_HAVE_SAME_EXONERATION_TVA') === 0) {
      messages.push({
        message: i18nType + '.annonceurWithSameExonerationTva',
      });
    }
    if (message.indexOf('CUMULATIV_DOWN_PAYMENT_AMOUNT_GREATER_THAN_AMOUNT') === 0) {
      messages.push({
        message: i18nType + '.sumMontantAcompteGreat',
      });
    }
    if (message.indexOf('FORBIDDEN_ON_SAME_PRODUCT_SAME_DATES') === 0) {
      messages.push({
        message: i18nType + '.sameProduct',
      });
    }
    if (message.indexOf('QTE_SOUHAITEE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.qteFacesSouhaiteesInf',
      });
    }
    if (message.indexOf('ECHEANCIERMERGE_VENTEINTERNE') === 0) {
      messages.push({
        message: i18nType + '.fusionEcheancierVenteInterne',
      });
    }
    if (message.indexOf('ANNEE_SEMAINE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.anneeSemaineRequired',
      });
    }
    if (message.indexOf('The AgenceId field is required.') === 0) {
      messages.push({
        message: i18nType + '.agenceId',
      });
    }
    if (message.indexOf('DATES_OVERLAP') === 0) {
      messages.push({
        message: i18nType + '.faceDateOverlap',
      });
    }
    if (message.indexOf('SHOUD_NOT_BE_EMPTY') === 0) {
      messages.push({
        message: i18nType + '.ShoudContainsLocationOrBillBoard',
      });
    }
    if (message.indexOf('TOTAL_HT_LOWER_THAN_DISCOUNT_LINE') === 0) {
      messages.push({
        message: i18nType + '.TotalHtLowerThanDiscountLine',
      });
    }
    if (message.indexOf('COMPTA_DISCOUNT_FORBIDDEN') === 0) {
      messages.push({
        message: i18nType + '.remiseInterditeCompta',
      });
    }
    if (message.indexOf('AMOUNT_INCORRECT') === 0) {
      messages.push({
        message: i18nType + '.wrongSigneEcheancier',
      });
    }
    if (message.indexOf('NEW_COMMAND_LINES_SHOULD_BE_AT_THE_END_IN_PARTIALLY_ORDERED_QUOTATION') === 0) {
      messages.push({
        message: i18nType + '.newCommandeLigneAtEnd',
      });
    }
    if (message.indexOf('ONLY_ONE_PAYER_MANAGEMENT_QUOTATION_ORDER') === 0) {
      messages.push({
        message: i18nType + '.onlyOnePayeur',
      });
    }
    if (message.indexOf('NO_CUSTOM_BUNDLE_LINE_MANAGEMENT_QUOTATION_ORDER') === 0) {
      messages.push({
        message: i18nType + '.noRegroupementPerso',
      });
    }
    if (message.indexOf('ECHEANCIER_MANUEL_SHOULD_HAVE_ECHEANCIER_LIGNE') === 0) {
      messages.push({
        message: i18nType + '.echeancierManuelShouldHaveEcheancierLignes',
      });
    }
    if (message.indexOf('GOOGLE_MAP_KEY_INVALID') === 0) {
      messages.push({
        message: i18nType + '.googleMapKeyInvalid',
      });
    }
    if (message.indexOf('COMMANDE_LOCKED_CLIENT') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.lockedClient',
        parametres: { nomCommercial: params[1] },
      });
    }
    if (message.indexOf('PRODUCT_SHOULD_BE_PURCHASE') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.productPurchase',
        parametres: { libelle: params[1] },
      });
    }
    if (message.indexOf('LIGNE_WITH_FACE_NOT_PROPOSABLE_LC') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.notProposableLc',
        parametres: { ref: params[2] },
      });
    }
    if (message.indexOf('LIGNE_DEVIS_COMMANDE_WITHOUT_LOCATION') === 0) {
      const libelle = message.split('|')[0].split('@')[1];
      messages.push({
        message: i18nType + '.ligneCommandeWithoutLigneLocation',
        parametres: { reseau: libelle },
      });
    }
    if (message.indexOf('DISCOUNT_NECESSARILY_LAST') === 0) {
      const params = message.split('|')[0].split('@');
      let msg = '.remiseRegieshouldBeLast';
      if (params[2] === '') msg = '.remiseRegieshouldBeLastWithoutRegroupement';
      messages.push({
        message: i18nType + msg,
        parametres: {
          libelle: params[1],
          produit: params[2],
        },
      });
    }
    if (message.indexOf('DISCOUNT_ONLY_ONE') === 0) {
      const params = message.split('|')[0].split('@');
      let msg = '.remiseRegieOnlyOne';
      if (params[2] === '') msg = '.remiseRegieOnlyOneWithoutRegroupement';
      messages.push({
        message: i18nType + msg,
        parametres: {
          libelle: params[1],
          produit: params[2],
        },
      });
    }
    if (message.indexOf('DISCOUNT_MUST_BE_PRECEDED_BY_SUBTOTAL') === 0) {
      const params = message.split('|')[0].split('@');
      let msg = '.remiseRegieMustBePreceded';
      if (params[2] === '') msg = '.remiseRegieMustBePrecededWithoutRegroupement';
      messages.push({
        message: i18nType + msg,
        parametres: {
          libelle: params[1],
          produit: params[2],
        },
      });
    }
    if (message.indexOf('COMMANDE_INTERVENANT_REFERENCE_HAVAS_REQUIED') === 0) {
      messages.push({
        message: i18nType + '.commandeIntervenantReferenceHavasRequired',
      });
    }
    if (message.indexOf('API_SPOT_HAVAS_ERROR_DEVIS') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.apiSpotHavasErrorDevis',
        parametres: { probleme: params[1] },
      });
    }

    if (messages.length === nbMessagesAvant && message) {
      messages.push({ message });
    }
  });
}
